var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeeroasters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E8784",
    d: "M22.123 9.378c2.89 2.89 2.387 8.1-1.126 11.613-1.688 1.687-3.813 2.74-5.987 2.965-.29.029-.576.044-.856.044-1.87 0-3.539-.656-4.769-1.886-1.416-1.414-2.07-3.412-1.839-5.625.224-2.173 1.277-4.299 2.964-5.986 3.515-3.512 8.724-4.019 11.613-1.125zm-.18.18c-.961 1.16-1.67 2.482-2.851 3.453-1.257 1.033-2.64 1.41-4.161 1.85-3.338.97-4.988 3.791-5.369 7.075 1.043-1.253 1.808-2.657 3.125-3.663 1.152-.88 2.398-1.227 3.754-1.598 3.411-.936 5.105-3.781 5.502-7.117zM13.49 3.003a10.573 10.573 0 012.165 3.151c-1.68.29-3.308.992-4.75 2.046a7.17 7.17 0 00-1.837-.84c-1.519-.44-2.903-.816-4.16-1.85-1.18-.971-1.889-2.296-2.852-3.454.396 3.336 2.091 6.182 5.502 7.118.576.157 1.128.32 1.666.511-1.626 1.713-2.696 3.8-3.07 5.97A10.607 10.607 0 013 13.491C-.508 9.978-1.014 4.768 1.877 1.878 4.766-1.014 9.975-.51 13.489 3.003z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeroasters);
export default __webpack_public_path__ + "static/media/coffeeroasters.70ce77dac433114a8f885c8bb1fb95cf.svg";
export { ForwardRef as ReactComponent };